import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa25dad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-template" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Beginnen Sie mit der Erstellung Ihrer Vorlage mit Text, Schaltflächen oder beidem. Sie können diese dann über den Posteingang an Kunden versenden. ", -1))
const _hoisted_3 = { class: "group-wrapper" }
const _hoisted_4 = { class: "item-wrapper" }
const _hoisted_5 = { class: "item-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "group-wrapper" }
const _hoisted_8 = { class: "item-wrapper" }
const _hoisted_9 = { class: "item-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "group-wrapper"
}
const _hoisted_11 = { class: "item-wrapper full" }
const _hoisted_12 = { class: "quickreply-wrapper" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Schnellantworten hinzufügen", -1))
const _hoisted_14 = { class: "actions" }
const _hoisted_15 = {
  key: 0,
  class: "group-wrapper"
}
const _hoisted_16 = { class: "item-wrapper full" }
const _hoisted_17 = { class: "call-to-action-wrapper" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Actionbuttons hinzufügen", -1))
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = {
  key: 0,
  class: "group-wrapper"
}
const _hoisted_21 = { class: "item-wrapper full" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Header-Text", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = { class: "group-wrapper" }
const _hoisted_25 = { class: "item-wrapper full" }
const _hoisted_26 = { class: "textarea-actions" }
const _hoisted_27 = { class: "group-wrapper" }
const _hoisted_28 = { class: "item-wrapper full" }
const _hoisted_29 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_tooltip = _resolveComponent("md-tooltip")!
  const _component_md_select = _resolveComponent("md-select")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_transition_slide = _resolveComponent("transition-slide")!
  const _component_md_textarea = _resolveComponent("md-textarea")!
  const _component_md_overlay = _resolveComponent("md-overlay")!

  return (_openBlock(), _createBlock(_component_md_overlay, {
    title: "Neues Template für WhatsApp-Nachrichten erstellen",
    ref: "overlay"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_md_tooltip, {
              text: "Nur klein Buchstaben, Zahlen und Unterstriche",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_md_input_field, {
                  required: "",
                  size: "small",
                  variant: "outlined",
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  label: "Name des Templates",
                  ref: "nameInput",
                  validator: _ctx.nameValidator
                }, null, 8, ["modelValue", "validator"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_md_select, {
              variant: "outlined",
              size: "small",
              icon: "expand_more",
              modelValue: _ctx.category,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.category) = $event)),
              label: "Kategorie",
              items: _ctx.categories,
              ref: "categoryInput"
            }, null, 8, ["modelValue", "items"])
          ])
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_md_select, {
              variant: "outlined",
              size: "small",
              icon: "expand_more",
              modelValue: _ctx.controlType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.controlType) = $event)),
              label: "Schaltflächen-Typ",
              items: _ctx.controlTypes,
              ref: "controlTypeInput"
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_md_select, {
              variant: "outlined",
              size: "small",
              icon: "expand_more",
              modelValue: _ctx.headerType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.headerType) = $event)),
              label: "Headertyp",
              items: _ctx.headerTypes,
              ref: "headerTypeInput"
            }, null, 8, ["modelValue", "items"])
          ])
        ]),
        _createVNode(_component_transition_slide, { direction: "left" }, {
          default: _withCtx(() => [
            (_ctx.controlType === 'quick_reply')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickReplies, (reply) => {
                        return (_openBlock(), _createBlock(_component_md_input_field, {
                          key: reply,
                          size: "small",
                          variant: "outlined",
                          modelValue: reply.text,
                          "onUpdate:modelValue": ($event: any) => ((reply.text) = $event),
                          label: "Button Text"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_md_button, {
                          icon: "add",
                          variant: "text",
                          disabled: this.quickReplies.length >= 3,
                          onClick: _ctx.addQuickReply
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Button hinzufügen")
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_transition_slide, { direction: "left" }, {
          default: _withCtx(() => [
            (_ctx.controlType === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionButtons, (action) => {
                        return (_openBlock(), _createBlock(_resolveDynamicComponent(action.component), {
                          key: action,
                          modelValue: action.data,
                          "onUpdate:modelValue": ($event: any) => ((action.data) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_md_button, {
                          icon: "add",
                          variant: "text",
                          disabled: this.actionButtons.length >= 2,
                          onClick: _ctx.addActionButton
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Button hinzufügen")
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_transition_slide, { direction: "left" }, {
          default: _withCtx(() => [
            (_ctx.headerType === 'text')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_md_input_field, {
                      required: "",
                      size: "small",
                      variant: "outlined",
                      modelValue: _ctx.header,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.header) = $event)),
                      label: "Header Text",
                      ref: "headerInput",
                      "max-characters": 30
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_md_textarea, {
              required: "",
              size: "small",
              variant: "outlined",
              modelValue: _ctx.content,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.content) = $event)),
              label: "Nachricht",
              ref: "contentInput",
              validator: _ctx.contentValidator,
              "max-characters": 1000
            }, null, 8, ["modelValue", "validator"]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_md_button, {
                variant: "text",
                icon: "add",
                onClick: _ctx.addVariable
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Variable hinzufügen")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_md_input_field, {
              size: "small",
              variant: "outlined",
              modelValue: _ctx.footer,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.footer) = $event)),
              label: "Footer",
              ref: "footerInput",
              error: false,
              "max-characters": 30
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_md_button, {
            variant: "filled",
            disabled: !_ctx.isFormValid,
            onClick: _ctx.addTemplate
          }, {
            default: _withCtx(() => [
              _createTextVNode("Template erstellen")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 512))
}